'use client';

import React, { createContext, useContext, useState } from 'react';
import GuidedWorkflow from '@/components/GuidedWorkflow';

interface GuidedWorkflowContextValue {
  guidedMode: boolean;
  toggleGuidedMode: () => void;
  setGuidedMode: (v: boolean) => void;
}

const GuidedWorkflowContext = createContext<GuidedWorkflowContextValue>({
  guidedMode: false,
  toggleGuidedMode: () => {},
  setGuidedMode: () => {},
});

export function useGuidedWorkflow() {
  return useContext(GuidedWorkflowContext);
}

export function GuidedWorkflowProvider({ children }: { children: React.ReactNode }) {
  const [guidedMode, setGuidedMode] = useState(false);

  const toggleGuidedMode = () => setGuidedMode((v) => !v);

  return (
    <GuidedWorkflowContext.Provider data-component-id="src/contexts/GuidedWorkflowContext.tsx:28:4" data-component-path="src/contexts/GuidedWorkflowContext.tsx" data-component-line="28" data-component-end-line="31" data-component-file="GuidedWorkflowContext.tsx" data-component-name="GuidedWorkflowContext.Provider" data-component-content="%7B%22elementName%22%3A%22GuidedWorkflowContext.Provider%22%7D" value={{ guidedMode, toggleGuidedMode, setGuidedMode }}>
      {children}
      <GuidedWorkflow data-component-id="src/contexts/GuidedWorkflowContext.tsx:30:6" data-component-path="src/contexts/GuidedWorkflowContext.tsx" data-component-line="30" data-component-end-line="30" data-component-file="GuidedWorkflowContext.tsx" data-component-name="GuidedWorkflow" data-component-content="%7B%22elementName%22%3A%22GuidedWorkflow%22%7D" isOpen={guidedMode} onClose={() => setGuidedMode(false)} />
    </GuidedWorkflowContext.Provider>
  );
}
